import React from 'react';
import { Box, Typography } from '@mui/material';

const CardHeader = ({
  title,
  titleBold = false,
  titleHelperText,
  subtitle,
  titleVariant = 'labelD',
  subtitleVariant = 'p3',
  alignItems = 'flex-start',
  titleColor = '#333333',
  subtitleColor = '#000000',
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems}}>
      {(title || titleHelperText) ? (
        <Typography variant={titleVariant} sx={{ textAlign: alignItems, color: titleColor,  fontWeight: { xs: '700 !important' ,md : '600'} }}>
          {title || ''}
          {titleHelperText ? (
            <Box component='span' sx={{ color: '#8C8C8C', ml: 0.5 }}>
              {titleHelperText}
            </Box>
          ) : null}
        </Typography>
      ) : null}
      {subtitle ? (
        <Typography variant={subtitleVariant}
          sx={{ color: titleColor, color: subtitleColor }}
        >
            {subtitle}
          </Typography>
      ) : null}
    </Box>
  );
};

export default CardHeader;
